import { render, staticRenderFns } from "./deal-privacy.vue?vue&type=template&id=55b859e2&scoped=true&"
import script from "./deal-privacy.vue?vue&type=script&lang=js&"
export * from "./deal-privacy.vue?vue&type=script&lang=js&"
import style0 from "./deal-privacy.vue?vue&type=style&index=0&id=55b859e2&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55b859e2",
  null
  
)

export default component.exports